<style scoped>
    .vs-table--tbody-table .tr-values td {
        padding: 3px;
    }
</style>

<template>
<div>
	<div class="vx-col w-full mb-base">
		<vs-card title="Inbound Details" class="p-4 mb-6">
         <div slot="header" class="flex flex-wrap items-center justify-between">
        	<div class="flex items-center">
	            <vs-button radius color="primary" icon="keyboard_backspace" @click="cancelAndBack()"></vs-button>
	        	<h4 class="ml-3">Add Good Receive</h4>
            </div>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="editInbound" v-show="!on_edit">Edit Inbound</vs-button>
          <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="addGoodReceive" v-show="on_edit" :disabled="inboundItems.length <= 0">Save</vs-button>
        </div>
		<div class="vx-row mt-6">
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound ID*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_id" disabled/>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR Reference*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="gr_reference"  :disabled="!on_edit" />
					</div>
				</div>
				<div class="vx-row mb-3 mt-1">
					<div class="vx-col w-1/3">
						Arrival Date*
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" v-model="arrival_date" :disabled="true" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						GR Date*
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" label="GR Date" v-model="gr_date" :disabled="!on_edit" />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Supplier ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="supplier_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, supplier)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in supplier.data" :key="index" :value="item.id" :text="item.name"/>
                        </vs-select>
						<!-- <v-select :options="supplierOption" label="name" v-model="supplier_id" @input="setSelected" :disabled="true" ></v-select> -->
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_1" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						&nbsp;
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="supplier_address_2" disabled />
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Client ID*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="client_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, client)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                        </vs-select>
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound Reference*
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_reference"  :disabled="true" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Order Type*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="order_type_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, order_type)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                        </vs-select>
					</div>
				</div>
			</div>
			<div class="vx-col lg:w-1/4 w-full">
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Inbound Status
					</div>
					<div class="vx-col w-2/3">
						<vs-input class="w-full" v-model="inbound_status.name" disabled />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						PO Date
					</div>
					<div class="vx-col w-2/3">
						<flat-pickr class="w-full" label="PO Date" v-model="po_date" :disabled="!on_edit" />
					</div>
				</div>
				<div class="vx-row mb-3">
					<div class="vx-col w-1/3">
						Warehouse*
					</div>
					<div class="vx-col w-2/3">
                        <vs-select
                            class="selectExample"
                            v-model="warehouse_id"
                            width="100%"
                            autocomplete
                            @input-change="searchDropdown($event, warehouse)"
                            disabled
                        >
                            <vs-select-item v-for="(item, index) in warehouse.data" :key="index" :value="item.id" :text="item.warehouses_code"/>
                        </vs-select>
					</div>
				</div>
			</div>
		</div>
		  <vs-tabs class="mt-10">
		  <vs-tab label="Item Details">
				<vs-button @click="addItem()" class="btn mr-1 mt-5" :disabled="client_id != null && on_edit ? false : true" type="border">Add</vs-button>
				<vs-button @click="removeItem()" class="btn mr-1 mt-5" :disabled="selected.length < 1 || !on_edit " type="border">Remove</vs-button>
                <vs-table v-model="selected" :data="inboundItems" hoverFlat class="mt-5" multiple pagination max-items="20">
                    <template slot="thead">
                        <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
                        <vs-th style="min-width: 200px;">Product ID</vs-th>
                        <vs-th style="min-width: 200px;">Description</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">UoM</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Stock Type</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Open Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Recv Qty</vs-th>
                        <vs-th style="min-width: 80px; width: 80px">Base Qty</vs-th>
                        <vs-th style="min-width: 120px; width: 120px">Base UoM</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <vs-input class="w-full" :value="indextr + 1" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.product_id.id"
                                    width="100%"
                                    @input="setSelectedProduct(tr)" 
                                    autocomplete
                                    :disabled="true"
                                >
                                <vs-select-item v-for="(item, index) in productOption" :key="index" :value="item.id" :text="item.product_code"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.description" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.pack_id" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.batch" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <flat-pickr class="w-full" v-model="tr.expired_date" :disabled="!on_edit || disabledFullyRecv(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-input :danger="tr.err" val-icon-danger="clear" class="w-full" v-model="tr.qty" :disabled="tr.product_id.id == '' || !on_edit || disabledFullyRecv(tr)" @input="Conversion(tr)"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.uom.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty <= 0 || !on_edit || disabledFullyRecv(tr)"
                                    @input="onChangeUom(tr)"
                                    @change="Conversion(tr)"
                                >
                                    <vs-select-item v-for="(item, index) in tr.uomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.stock_type_id"
                                    width="100%"
                                    autocomplete
                                    :disabled="tr.qty <= 0 || !on_edit || disabledFullyRecv(tr)"
                                >
                                    <vs-select-item v-for="(item, index) in tr.stockTypeOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.open_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.recv_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.base_qty" :disabled="true"/>
                            </vs-td>
                            <vs-td>
                                <vs-select
                                    class="selectExample"
                                    v-model="tr.base_uom.id"
                                    width="100%"
                                    autocomplete
                                    :disabled="true"
                                >
                                    <vs-select-item v-for="(item, index) in tr.baseUomOption" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-tab>
			<vs-tab label="Transport and Unloading">
				<div class="vx-row mt-6">
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Checker
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="checker"/>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Supervisor
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="supervisor"/>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Start Unloading
							</div>
							<div class="vx-col w-2/3">
								<flat-pickr class="w-full" v-model="start_unloading"/>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								End Unloading
							</div>
							<div class="vx-col w-2/3">
								<flat-pickr class="w-full" v-model="end_unloading"/>
							</div>
						</div>
					</div>
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Vehicle ID
							</div>
							<div class="vx-col w-2/3">
								<v-select :options="vehicleOption" label="vehicle_code" v-model="vehicle_id" :disabled="!on_edit" ></v-select>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Driver
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="driver" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Vehicle Type
							</div>
							<div class="vx-col w-2/3">
								<v-select :options="vehicleTypeOption" label="vehicle_type" v-model="vehicle_type_id" :disabled="!on_edit" ></v-select>
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Transporter
							</div>
							<div class="vx-col w-2/3">
								<v-select :options="transporterOption" label="transporter_code" v-model="transporter" :disabled="!on_edit" ></v-select>
							</div>
						</div>
					</div>
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Container Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full mb-2" v-model="container_number" :disabled="!on_edit" />
							</div>
						</div>
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Seal Number
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full mb-2" v-model="seal_number" :disabled="!on_edit" />
							</div>
						</div>
					</div>
				</div>
			</vs-tab>
		  <vs-tab label="Notes">
				<vs-textarea height="200" class="mt-5" label="Notes" v-model="remark" :disabled="!on_edit"/>			  
		  </vs-tab>
		</vs-tabs>
		</vs-card>
	</div>
 </div>
</template>

<script type="text/javascript">
	import vSelect from 'vue-select'
	import { AgGridVue } from "ag-grid-vue"
	import InboundItem from '@/components/InboundItem.vue'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	import '@/assets/scss/vuesax/_wmsTheme.scss';

	export default {
		name:"inb-create",
		components:{
			vSelect,
			flatPickr,
			InboundItem,
			AgGridVue,
		},
		data(){
			return {
                selected: [],
					data_conv:0,
				    isLoading:false,
					inbound_id:'',
					inbound_reference:'',
          gr_reference:'',
					arrival_date:'',
					saveState:false,
					on_edit:false,

          old_open_qty:'',
          old_base_qty:'',
          old_qty:'',
          			gr_date: new Date(),
					supplier_id:'',
					supplier_address_1:'',
					supplier_address_2:'',
					inbound_status:{},
					client_id:null,
					order_type_id:'',
					warehouse_id:'',
					po_date:'',
					remark:'',

					data:{
							line_id:'',
							product_id:'',
							descriptions:'',
							pack_id:'',
							batch:'',
							expired_date:'',
							uom_id:'',
							qty:'',
							base_uom:'',
							base_qty:'',
							open_qty:'',
							recv_qty:'',
					},
					oldInboundItems:[],
					singleItem:{},
					// transport
					checker:'',
					supervisor:'',
					start_unloading:'',
					end_unloading:'',
					vehicle_id:'',
					driver:'',
					vehicle_type_id:'',
					transporter:'',
					container_number:'',
					seal_number:'',
					// end-transport

			        inboundItems:[],
			        dataItemList:[],
			        clientDDL: null, 
			        clientOption: [],
			        warehouseDDL: null, 
			        warehouseOption: [],
			        orderTypeDDL: null, 
			        orderTypeOption: [],
			        supplierDDL: {}, 
			        supplierOption: [],

			        // Table-config
		            gridOptions: {},
		            maxPageNumbers: 7,
		            gridApi: null,
		            clients: [],
		            columnDefs: null,
		            defaultColDef: {
		                sortable: true,
		                editable: true,
		                resizable: true,
		                suppressMenu: true
		            },
		            productOption:[],
		            stockTypeOption:[], 
		            vehicleOption:[],
		            vehicleTypeOption:[],
                    transporterOption:[],
                    supplier: {
                        data: [],
                        loading: false,
                        endpoint: 'master/customers',
                        objectKey: 'name'
                    },
                    client: {
                        data: [],
                        loading: false,
                        endpoint: 'master/clients',
                        objectKey: 'client_code'
                    },
                    order_type: {
                        data: [],
                        loading: false,
                        endpoint: 'master/ordertypes',
                        objectKey: 'order_type'
                    },
                    warehouse: {
                        data: [],
                        loading: false,
                        endpoint: 'master/warehouses',
                        objectKey: 'warehouses_code'
                    }
			}
		},
	watch:{
	    isLoading: function(){
	        if(this.isLoading){
	            this.$vs.loading()
	        }
	        else{
	            this.$vs.loading.close()
	        }
	    }
	},
    beforeMount() {
        if(this.isLoading){
            this.$vs.loading()
        }
    },	
	methods:{
		disabledFullyRecv(data){
			if(data.old_recv_qty != 0 && data.old_open_qty == 0 && data.old_recv_qty == data.old_base_qty && this.inbound_status.id > 1){
				return true;
			}else{
				return false;
			}
		},
		cancelAndBack(){
			if(this.on_edit){
			    this.$vs.dialog({
			        type: 'confirm',
			        color: 'warning',
			        title: `Leave Page`,
			        text: 'Changes you made may not be saved?',
			        accept: () => {
							this.$router.replace('/good-receive');
			        }
			      })
			}else{
				this.$router.go(-1);
			}
		},
	    setSelectedProduct(value) {
	    	if(value != null){
			this.$http.get('/master/product/'+value.product_id.id)
			  .then((response) =>  {
			  	let prd = response.data; 
				  value.description = prd.product.description_1 != null ? prd.product.description_1 : '';
		          value.uomOption = [];
		          value.baseUomOption = [];
		          // for(let i = 0; i < prd.uoms.length; i++){
		          //     this.uomOption.push({...prd.uoms[i].uom, label:prd.uoms[i].uom.name,});
		          // }
		              // console.log("base_uom : "+JSON.stringify(prd.default_uom.uom.name)); 
		          	  // value.uomOption = prd.uoms;
		          	  prd.uoms.map(item => {
                            value.uomOption.push(item.uom);
                        })
		    		  // console.log(JSON.stringify(value.uomOption));
		              value.baseUomOption.push(prd.default_uom.uom);
		              value.uom = prd.default_uom.uom ;
		              value.base_uom = prd.default_uom.uom ;
			  })
			  .catch(function (error) {
			    console.log(error);
			  });
	          
	    	}else{
	    		 this.uom = null;
	    		 this.uomOption = [];
		         this.base_uom = null;
		         this.baseUomOption = [];
		         this.descriptions = '';
	    	}
 		},
		addItem(){
			let id = 0
			this.oldInboundItems.map(old => {
				let exist = false
				this.inboundItems.map(current => {
					if(current.id == old.id) {
						exist = true
					}
				})

				if(!exist) {
					let newItem = JSON.parse(JSON.stringify(old))
					this.inboundItems.push(newItem)
				}
				else {
					let totalBaseQty = 0
					this.inboundItems.map(item => {
						if(item.id == old.id) {
							totalBaseQty += item.base_qty
						}
					})

					if(totalBaseQty < old.base_qty) {
						let newItem = JSON.parse(JSON.stringify(old))
						newItem.base_qty = old.base_qty - totalBaseQty
						this.inboundItems.push(newItem)

						this.inboundItems.map(item => {
							if(item.id == newItem.id) {
								item.open_qty = 0
							}
						})
					}
				}
			})

			this.inboundItems.map(item => {
				this.onChangeUom(item)
				item.qty = this.setQty(item)
			})

			this.generateLineId()
		},
		// setSelected(value) {
		// 	this.supplier_address_1 = value != null ? value.address_1 : '';
		// 	this.supplier_address_2 = value != null ? value.address_2 : '';
     	// },
	    onChangeUom(data){
	  		data.uomOption.map(uom => {
				if(uom.id == data.uom.id) {
					data.denominator = uom.denominator
					data.numerator = uom.numerator
				}
			})
	  	},
     	onChangeClient(value){
     		if(value == null){
        	    this.$vs.dialog({
			        type: 'confirm',
			        color: 'warning',
			        title: `Warning`,
			        text: 'Changing Client ID will be delete All Inbound Items',
			        accept: () => {
     					this.dataItemList= [];
			        }
			      })
     		}
     	},
     	clicked(value){
     		let ar = this.dataItemList;
     		for(let i=0; i < ar.length; i++) {
			   if(ar[i].item_id == value.item_id)
			   {
			      ar.splice(i,1);
			   }
			}
     		this.dataItemList.push(value);
     	},
 	    removeItem(index){
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: `Warning`,
                text: `Are you sure want to delete ${this.selected.length} line?`,
                accept: () => {
                    let indexes = []
                    this.selected.map(selected => {
                        this.inboundItems.map((detail, index) => {
                            if(selected.line_id == detail.line_id) {
                                indexes.push(index)
                            }
                        })
                    })

                    indexes.sort((a, b) => b - a)
                    indexes.map(i => {
                        this.inboundItems.map(item => {
                            if(item.id == this.inboundItems[i].id) {
                                item.open_qty += this.inboundItems[i].base_qty
                            }
                        })

                        this.inboundItems.splice(i, 1)
                    })
                    this.selected = []
					this.generateLineId()
                }
            })
        },
        validationDetail(data){
	        // if(this.inbound_status.id > 1){

            // if(data.qty == 0 || data.qty == ''){
            //   data.errText = 'qty cant be 0';
            //   data.err = true;
            //   data.open_qty = data.old_open_qty ;
            //   // data.qty = old_qty ;
            //   data.base_qty = data.old_base_qty ;
            //   console.log('here 1');
            // }else 
            if(this.data_conv > (data.old_recv_qty + data.old_open_qty)){
              data.errText = 'qty cant higher than open qty';
              data.err = true;
              data.qty = 0 ;
              data.open_qty = data.old_open_qty ;
              data.base_qty = 0 ;
              data.uom.id = data.old_uom_id;
              console.log('here 1');
            }
            else{
              var sisa = data.old_open_qty - this.data_conv
              if(sisa < 0 ){
  	              data.errText = 'qty cant lower than open qty';
	              data.err = true;
	              data.qty = data.old_open_qty ;
	              data.open_qty = 0 ;
	              console.log('here 2');
	              data.base_qty = data.old_base_qty ;
	              // data.uom.id = data.old_uom_id;
              }else{
	              data.open_qty = sisa ;
	              data.base_qty = this.data_conv ; 
	              data.errText = '';
	              data.err = false;
	              console.log('here 3');
              }
            }

	        // }else{
	        // 	let sisa = old_open_qty - this.data_conv;
	        // 	data.open_qty = sisa;
         //    data.base_qty = this.data_conv;
	        // 	data.errText = '';
        	//  	data.err = false;
	        // 	console.log('here 4 : ');
	        // }
        },
	    Conversion : function(data){
	    	let total_qty = data.base_qty + data.open_qty
			let open_qty = 0
			let base_qty = 0
	    	if(data.qty > 0){
				data.base_qty = (data.qty / data.denominator) * data.numerator
				data.open_qty = total_qty - data.base_qty
				data.err = false;
				data.errText = '';

				open_qty = data.open_qty
				base_qty = data.base_qty
	    	}else{
	        	data.base_qty = 0;
				data.open_qty = total_qty
				open_qty = data.open_qty
				base_qty = data.base_qty
        	 	data.err = true;
    		  	data.errText = 'qty must be higer than 0';
	    	}

			this.inboundItems.map(item => {
				if(data.inbound_details_id == item.inbound_details_id) {
					item.open_qty = open_qty
				}
			})
		},
		setQty(item) {
			return (item.base_qty * item.denominator) / item.numerator
		},
	    generateLineId(){
	    	let id = 1
			this.inboundItems.map(item => {
				item.line_id = id
				id++
			})
	    },
     	editInbound(){
     		this.isLoading = true;
	        function getProduct(ax) {
	          return ax.post('/master/product');
	        }	
	        function getClient(ax) {
	          return ax.post('/master/clients');
	        }	         
	        function getWarehouse(ax) {
	          return ax.post('/master/warehouses');
	        }  
	        function getOrderTypes(ax) {
	          return ax.post('/master/ordertypes');
	        }  
	        function getSuppliers(ax) {
	          return ax.post('/master/suppliers');
	        }  
	        function getVehicle(ax) {
	          return ax.post('/master/vehicle');
	        }
	        function getVehicleType(ax) {
	          return ax.post('/master/vehicletypes');
	        }
	        function getTransporter(ax) {
	          return ax.post('/master/transporters');
	        }          

	        if(this.clientOption.length == 0 && this.warehouseOption.length == 0 
	         && this.orderTypeOption.length == 0  && this.orderTypeOption.length == 0 
	         && this.supplierOption.length == 0){
		        this.$http.all([getProduct(this.$http), getClient(this.$http), getWarehouse(this.$http), getOrderTypes(this.$http), getSuppliers(this.$http)])
		          .then(this.$http.spread((product,clients, warehouses, ordertypes, suppliers) => {

		            this.productOption = [];
		            this.clientOption = [];
			        this.warehouseOption = [];
			        this.orderTypeOption =  [];
			        this.supplierOption =  [];
			        this.vehicleOption =  [];
			        this.vehicleTypeOption =  [];
			        this.transporterOption =  [];

		            this.productOption = product.data.data;
		            this.clientOption = clients.data.data;
			        this.warehouseOption = warehouses.data.data;
			        this.orderTypeOption =  ordertypes.data.data;
			        this.supplierOption =  suppliers.data.data;

			        this.getTransportUnloading();

			        this.isLoading = false;

		          }));
	        }
			this.on_edit = true;
     	},
     	getTransportUnloading(){

	        function getVehicle(ax) {
	          return ax.post('/master/vehicle');
	        }
	        function getVehicleType(ax) {
	          return ax.post('/master/vehicletypes');
	        }
	        function getTransporter(ax) {
	          return ax.post('/master/transporters');
	        }          

	        if(this.vehicleOption.length == 0 && this.vehicleTypeOption.length == 0 
	         && this.transporterOption.length == 0){
		        this.$http.all([getVehicle(this.$http), getVehicleType(this.$http), getTransporter(this.$http)])
		          .then(this.$http.spread((vehicles, vehicle_types, transporters) => {

			        this.vehicleOption =  [];
			        this.vehicleTypeOption =  [];
			        this.transporterOption =  [];

			        this.vehicleOption =  vehicles.data.data;
			        this.vehicleTypeOption =  vehicle_types.data.data;
			        this.transporterOption =  transporters.data.data;

		          }));
	        }
     	},
     	addGoodReceive(){

	     	if(this.gr_reference == '' || this.inbound_reference == '' ||!this.supplier_id || !this.client_id 
	     	|| !this.order_type_id || !this.warehouse_id || this.gr_date == '' || this.po_date == '' ){

	 		   this.$vs.notify({
	                color: 'danger',
	                title: 'Error Header ',
	                iconPack: 'feather',
	                icon:'icon-x',
	                text: 'Please Check Data Inbound Detail'
	            })
	            return;
	     	}

	        for(let detail of this.inboundItems){
	            if(!detail.product_id || !detail.uom || detail.err == true ) {
	                console.log('detail.err : '+detail.err)
	                console.log('detail.product_id  : '+detail.product_id )
	                console.log('detail.uom_id  : '+detail.uom_id )
	                this.$vs.notify({
	                    color: 'danger',
	                    title: 'Error Item Product',
	                    iconPack: 'feather',
	                    icon:'icon-x',
	                    text: 'Check Product Line ' + detail.line_id
	                })
	                return;
	            }
	        }

     		this.isLoading= true ;
			let inbound_head = {
			 inbound_id:this.inbound_id,
	         gr_reference:this.gr_reference,
	         gr_date:this.gr_date,
	         inbound_reference:this.inbound_reference,
	         supplier_id:this.supplier_id,
	         client_id:this.client_id,
	         order_type_id:this.order_type_id,
	         warehouse_id:this.warehouse_id,
	         posting_date:this.po_date,
	         req_del_date:this.arrival_date,
	         remark:this.remark,
	       };

	      let transport_unloading = {
			        checker: this.checker,
			        supervisor:this.supervisor,
			        start_unloading: this.start_unloading,
			        end_unloading: this.end_unloading,
			        vehicle_id: this.vehicle_id,
			        driver: this.driver,
			        vehicle_type_id: this.vehicle_type_id,
			        transporter_id: this.transporter,
			        container_number:this.container_number,
			        seal_number:this.seal_number, 
			}


	       	 let data_details = [];
	         this.inboundItems.map(item => {
	            let obj = {
	                inbound_id:this.inbound_id,
	                inbound_details_id:item.id,
	                inbound_details_line_id:item.line_id,
	                line_id:item.line_id,
	                product_id:item.product_id.id,
	                pack_id:item.pack_id,
	                batch:item.batch,
	                expired_date:item.expired_date,
	                uom_id:item.uom.id,
	                stock_type_id:item.stock_type_id,
	                qty:item.qty,
	                base_uom_id:item.base_uom.id,
	                open_qty:item.open_qty,
	                recv_qty:item.recv_qty,
	                base_qty:item.base_qty,
	                status:'insert',
	              };
	            data_details.push(obj);
	         });


	       let data_send = {
	        good_receive : inbound_head,
	        good_receive_details : data_details,
	       	transport_unloading :transport_unloading,
	       };	
        
	        this.$http.post('/inbound/goodreceive/store',data_send)
	        .then((resp) => {
	           // let rstr = JSON.stringify(resp.data);
	         this.isLoading = false ;
	         this.$router.push({
			          name: 'good-receive-view',
			          params: {
			              id: resp.data.good_receive_id,
			          }
			      });
             this.$vs.notify({
                color: 'success',
                title: 'Create Succesfully',
                text: 'Succesfully Create : '+this.gr_reference
              });
	        })
	        .catch((resp) =>{
				const message = resp.response.data.message ? resp.response.data.message : 'Something went wrong.'
	        this.isLoading= false ;	
	         this.$vs.notify({
		        color: 'danger',
		        title: 'Error',
		        text: message
		      });
	          this.errText = message
	        });


     	}
	},
    mounted(){
        function getProductbyId(ax, id) {
            return ax.get('master/product/'+id);
        }
        function getStockType(ax) {
            return ax.post('/master/stocktypes');
        }

		this.gridApi = this.gridOptions.api;
    	if(this.$route.params.inbound_object != undefined){
            
    		this.on_edit = true;
			this.isLoading = true;
	   // this.$http.get('inbound/inbounddelivery/'+this.$route.params.id)
    //     .then((resp) => {
    		let data = this.$route.params.inbound_object ;

        	let header = data.inbound ;
        	this.inbound_id = header.id ;
        	this.inbound_reference = header.inbound_reference ;
        	this.arrival_date = header.req_del_date ;
        	// this.supplier_id = header.supplier_id ;
        	this.supplier_address_1 = header.supplier.address_1 ;
        	this.supplier_address_2 = header.supplier.address_2 ;
        	this.inbound_status = header.status ;
        	this.po_date = header.po_date ;
        	this.supplier_id = header.supplier.id;
            this.client_id = header.client.id;
            this.order_type_id = header.order_type.id;
            this.warehouse_id = header.warehouse.id;

            this.client.data.push(header.client)
            this.order_type.data.push(header.order_type)
            this.warehouse.data.push(header.warehouse)
            this.supplier.data.push(header.supplier)

            // custom
            if(data.inbounddetailcustom.length > 0){
            	let custom = data.inbounddetailcustom[0];
	            this.aju_number = custom.aju_number || '';
	            this.sppb_number = custom.sppb_number ;
	            this.sppb_date = custom.sppb_date ;
	            this.blorawb = custom.blorawb ;
	            this.registration_number = custom.registration_number ;
	            this.registration_date = custom.registration_date ;
            }

            this.productOption = [];

			this.getTransportUnloading();

			const getStockTypes = () => {
				return new Promise((resolve, reject) => {
					if(this.stockTypeOption.length < 1) {
						getStockType(this.$http)
						.then(res => {
							this.stockTypeOption = res.data.data
							resolve()
						})
						.catch(error => {
							console.log(error)
							reject(error)
						})
					}
					else {
						resolve()
					}
				})
			}

			getStockTypes()
			.then(() => {
				this.isLoading = false
				data.inbounddetails.map((item, index) => {
					this.productOption.push(item.product);
						let data_uom = [] ;
						item.product.uoms.map(uoms => {
							uoms.uom.numerator = uoms.numerator
							uoms.uom.denominator = uoms.denominator
							data_uom.push(uoms.uom);
						});

						let item1 = JSON.parse(JSON.stringify(item))
						let item2 = JSON.parse(JSON.stringify(item))

						this.inboundItems.push({
							...item1,
							status:'exist',
							description: item.product.description_1,
							product_id:item.product,
							inbound_details_id:item.id, 
							old_qty:item.qty, 
							old_open_qty:item.open_qty, 
							old_base_qty:item.base_qty, 
							old_recv_qty:item.recv_qty, 
							first_item_qty:item.open_qty,
							open_qty:0, 
							old_uom_id:item.uom.id,
							productOption:[item.product], 
							uomOption:data_uom, 
							baseUomOption:[item.base_uom], 
							stockTypeOption:this.stockTypeOption, 
							stock_type_id:1,
							old_line_id:0, 
							err:false, 
							errText:''
						})

						this.oldInboundItems.push({
							...item2,
							status:'exist',
							description: item.product.description_1,
							product_id:item.product,
							inbound_details_id:item.id, 
							old_qty:item.qty, 
							old_open_qty:item.open_qty, 
							old_base_qty:item.base_qty, 
							old_recv_qty:item.recv_qty, 
							first_item_qty:item.open_qty,
							open_qty:0, 
							old_uom_id:item.uom.id,
							productOption:[item.product], 
							uomOption:data_uom, 
							baseUomOption:[item.base_uom], 
							stockTypeOption:this.stockTypeOption, 
							stock_type_id:1,
							old_line_id:0, 
							err:false, 
							errText:''
						})

						this.inboundItems.map(item => {
							this.onChangeUom(item)
						})

						this.generateLineId()
				});
			})
        // })
        // .catch((resp) =>{
        //   console.log(resp);
        //   // if(resp.response.status == 500){
        //   // } 
        // });

        }else{
            this.$router.replace('/good-receive');
        }
    },
	}
</script>

